import * as React from "react";
import * as ReactDOM from "react-dom";
import "./index.css";
import Main from "./Main";

ReactDOM.render(
	<React.StrictMode>
		<Main />
	</React.StrictMode>,
	document.getElementById("root")
);
